var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      ref: "form_step_1",
      model: {
        value: _vm.form,
        callback: function ($$v) {
          _vm.form = $$v
        },
        expression: "form",
      },
    },
    [
      _c("contact-information", {
        staticClass: "mt-5",
        attrs: { "validation-id": _vm.v__validationId },
      }),
      _vm._v(" "),
      _c("dates-of-rental", {
        staticClass: "mt-5",
        attrs: { "validation-id": _vm.v__validationId },
      }),
      _vm._v(" "),
      _vm.is_delivery ? _c("DeliveryBlock", { staticClass: "mt-5" }) : _vm._e(),
      _vm._v(" "),
      _c("steps-navigation", {
        attrs: { errors: _vm.v__getErrors(), "back-button": false },
        on: { "step-next": _vm.stepNext },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }